<script setup lang="ts">

const { t } = useI18n()

const qnas = (section: string, keys: string[]) =>
  keys.map((key) => ({
    label: t(`faq.${section}.${key}.title`),
    content: t(`faq.${section}.${key}.text`),
  }))

const items = [
  {
    label: t('faq.setup.title'),
    qnas: qnas('setup', [
      'buyOnline',
      'onboarding',
      'equipment',
      'import',
      'payment',
      'branches',
      'devices',
      'employees',
      'eet',
    ]),
  },
  {
    label: t('faq.usage.title'),
    qnas: qnas('usage', ['support', 'eVouchers', 'security', 'updates']),
  },
]
</script>

<template>
  <UiSection id="faq" :title="$t('faq.title')">
    <div v-for="item in items" class="mb-4 block rounded-2xl transition-all">
      <div class="block rounded-2xl bg-optilynx-purple transition-all">
        <h3 class="w-full pt-4 text-center text-2xl font-semibold text-white">
          {{ item.label }}
        </h3>
        <div class="flex flex-col gap-2 p-4 transition-all">
          <UiAccordion :items="item.qnas" />
        </div>
      </div>
    </div>
  </UiSection>
</template>
